import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PEV } from "../../../common/utils";
import { ProgressErrorValue } from "../../../common/utils/progress-error-value";
import { fetchInformationAssetUsers } from "../service/fetchInformationAssetUsers";

export class InformationAssetUser {
    email: string;
    jobProfile: string | null;
    fullName: string | null;
    employeeId: string | null;

    constructor(informationAssetUser: InformationAssetUser) {
        this.email = informationAssetUser.email
        this.jobProfile = informationAssetUser.jobProfile
        this.fullName = informationAssetUser.fullName
        this.employeeId = informationAssetUser.employeeId
    }
}

export interface InformationAssetSystemUser {
    informationAssetUserPEV: ProgressErrorValue<InformationAssetUser[]>
}

const initialState: InformationAssetSystemUser = {
    // @ts-ignore
    informationAssetUserPEV: PEV([], "Not loaded yet"),
};

const getInformationAssetUsers = createAsyncThunk("information-asset-users/fetch", async (emailList: string[]) => {
    return await fetchInformationAssetUsers(emailList);
});

const InformationAssetUserSlice = createSlice({
  name: "InformationAssetUser",
  initialState,
  reducers: {
    resetInformationAssetSystemUserState: (state: InformationAssetSystemUser) => {
      state.informationAssetUserPEV = initialState.informationAssetUserPEV;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInformationAssetUsers.pending, (state) => {
        state.informationAssetUserPEV = PEV(
          [], // @ts-ignore
          "Fetching information assets accesses"
        );
      })
      .addCase(getInformationAssetUsers.fulfilled, (state, action) => {
        state.informationAssetUserPEV = PEV(action.payload);
      })
      .addCase(getInformationAssetUsers.rejected.type, (state, action) => {
        // @ts-ignore
        state.informationAssetUserPEV = PEV(
          state.informationAssetUserPEV.value,
          null, // @ts-ignore
          "Error while fetching asset users"
        );
      });
  },
});

const { resetInformationAssetSystemUserState } = InformationAssetUserSlice.actions;
export const InformationAssetUserReducer = InformationAssetUserSlice.reducer

export const InformationAssetUserAction = {
  getInformationAssetUsers,
  resetInformationAssetSystemUserState,
};

